import styles from "../../styles.module.scss";
import settingsService from "../../api/settingsService";
import classNames from "classnames";
import { useEffect } from "react";
import NotaIcon from "formassets/nota.svg?react";

import { CircularProgress, useMediaQuery } from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Form from "../../components/Form";

function EmbedForm() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get("id");
  const inline = urlParams.get("inline") === "true";
  const isMobile = useMediaQuery("(max-width: 767px)");

  // W ramce (inline) podajemy rodzicowi wysokość treści, żeby mógł dopasować do niej iframe —
  // bez wewnętrznego paska przewijania i pustego pasa pod formularzem (landing notaup.pl).
  // Rodzic, który nie nasłuchuje NOTA_FORM_HEIGHT, po prostu ignoruje komunikat.
  useEffect(() => {
    if (!inline || window.parent === window) return;
    const postHeight = () =>
      window.parent.postMessage(
        {
          type: "NOTA_FORM_HEIGHT",
          height: Math.ceil(document.body.getBoundingClientRect().height),
        },
        "*",
      );
    const observer = new ResizeObserver(postHeight);
    observer.observe(document.body);
    return () => observer.disconnect();
  }, [inline]);

  const { data: logoData } = settingsService.useGetLogo(id ?? "", !!id);
  const {
    data: formData,
    isLoading: isLoadingFormSettings,
    isLoadingError,
  } = settingsService.useGetForm(id ?? "", !!id);

  const theme = `theme${formData?.data?.Theme ?? 0}`;

  const getThemeStyle = () => {
    switch (theme) {
      case "theme0":
        return styles.theme0;
      case "theme1":
        return styles.theme1;
      case "theme2":
        return styles.theme2;
      case "theme3":
        return styles.theme3;
      case "theme4":
        return styles.theme4;
      case "theme5":
        return styles.theme5;
      case "theme6":
        return styles.theme6;
    }
  };

  const notFound = () => {
    return (
      <div
        className={classNames(
          styles.root,
          inline ? styles.inline : undefined,
          getThemeStyle(),
        )}
      >
        {!inline && <div className={styles.bgl}></div>}
        {!inline && <div className={styles.bgr}></div>}

        {!inline && (
          <div className={styles.ourlogo}>
            Powered by <NotaIcon></NotaIcon>
          </div>
        )}
        <div className={styles.fail}>
          <div className={styles.ico}>
            <ErrorOutlineOutlinedIcon></ErrorOutlineOutlinedIcon>
          </div>
          <div className={styles.msg}>Formularz nie istnieje</div>
        </div>
      </div>
    );
  };

  const loading = () => {
    return (
      <div
        className={classNames(
          styles.root,
          inline ? styles.inline : undefined,
          getThemeStyle(),
        )}
      >
        {!inline && <div className={styles.bgl}></div>}
        {!inline && <div className={styles.bgr}></div>}

        {!inline && (
          <div className={styles.ourlogo}>
            Powered by <NotaIcon></NotaIcon>
          </div>
        )}
        <div className={styles.loading}>
          <CircularProgress />
        </div>
      </div>
    );
  };

  if (isLoadingError) {
    return notFound();
  }

  if (isLoadingFormSettings) {
    return loading();
  }

  return (
    <div
      className={classNames(
        styles.root,
        inline ? styles.inline : undefined,
        getThemeStyle(),
      )}
    >
      <div
        className={classNames(styles.root2, inline ? styles.inline : undefined)}
      >
        {!inline && <div className={styles.bgl}></div>}
        {!inline && <div className={styles.bgr}></div>}

        {!inline && !isMobile && (
          <div className={styles.logo}>
            {logoData?.data && (
              <img src={URL.createObjectURL(logoData?.data)} alt="Logo" />
            )}
          </div>
        )}
        {!inline && !isMobile && (
          <div className={styles.ourlogo}>
            Powered by <NotaIcon></NotaIcon>
          </div>
        )}
        <div className={styles.formWrapper}>
          <Form
            id={id}
            inline={inline || isMobile}
            settings={formData?.data}
          ></Form>
        </div>
      </div>
    </div>
  );
}

export default EmbedForm;
